import { SchemasRoutes } from '@modules/Schemas/SchemasRoutes';
import React, { useEffect } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { RoutesWrap } from './components/router/RoutesWrap';
import { GlobalStyle } from './GlobalStyle';
import './ng-converted-components';
import { configure } from 'mobx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAngularEventOn } from '../static/react-injector/src/hooks/useAngularEventOn';
import { ReportsRoutes } from './modules/Reports/ReportsRoutes';
import { WorkflowsRoutes } from './modules/Workflows/WorkflowsRoutes';
import { ComponentsRoutes } from '../static/react-injector/src/injectables/modules/Components';
import { SignalsRoutes } from '../static/react-injector/src/injectables/modules/Signals';
import { FunctionsRoutes } from '../static/react-injector/src/injectables/modules/Functions';
import { ReactInjectorApp } from '../static/react-injector/src/App.tsx';
import { IconsContext } from '@progress/kendo-react-common';

configure({
    enforceActions: 'never',
});

const theme = require('./theme').default;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

function AssignBodyRouteClass() {
    useEffect(() => {
        document.body.classList.add('react-app-route');
    }, []);

    useAngularEventOn('$routeChangeStart', function (event, nextAngularRoute) {
        if (nextAngularRoute) {
            document.body.classList.remove('react-app-route');
        } else {
            document.body.classList.add('react-app-route');
        }
    });

    return null;
}

// @ts-ignore
const forModule = (name, component) => (window.configObject.modules[name] ? component : null);

export const App = () => {
    return (
        <React.StrictMode>
            <IconsContext.Provider value={{ type: 'font' as any }}>
                <ThemeProvider theme={theme}>
                    <StyleSheetManager disableCSSOMInjection={true}>
                        <QueryClientProvider client={queryClient}>
                            <GlobalStyle />
                            <AssignBodyRouteClass />

                            <HashRouter>
                                {/*<HashRouter getUserConfirmation={getUserConfirmation}>*/}
                                <RoutesWrap>
                                    {[
                                        forModule('de', <WorkflowsRoutes key="workflows" />),
                                        forModule('de', <SchemasRoutes key="schemas" />),
                                        forModule('report-list', <ReportsRoutes key="reports" />),
                                        forModule('de', <ComponentsRoutes key="components" />),
                                        forModule('de', <SignalsRoutes key="signals" />),
                                        forModule('functions', <FunctionsRoutes key="functions" />),
                                    ].filter((route) => !!route)}
                                </RoutesWrap>
                            </HashRouter>

                            {/*Legacy react part*/}
                            <ReactInjectorApp />
                        </QueryClientProvider>
                    </StyleSheetManager>
                </ThemeProvider>
            </IconsContext.Provider>
        </React.StrictMode>
    );
};

export default App;
